'use client'
import React, { useState } from 'react'

type SwitchPropsType = {
  onChange?: (value: boolean) => void
  value?: boolean
}

export default function Switch({ onChange, value }: SwitchPropsType) {
  const [isOn, setIsOn] = useState(value)

  const toggleSwitch = () => {
    onChange ? onChange(!isOn) : setIsOn(!isOn)
  }

  return (
    <div
      className={`relative cursor-pointer border border-tabBorder inline-block rounded-full w-9 h-5 align-middle select-none transition duration-150 ease-in ${
        (onChange ? value : isOn) ? 'bg-primary-500' : 'bg-c'
      }`}
      onClick={toggleSwitch}
    >
      <button
        className={`absolute h-3.5 w-3.5 m-0.5 block border bg-white transition duration-200 ease-in rounded-full shadow inset-y-0 left-0 focus:outline-none ${
          (onChange ? value : isOn) ? 'translate-x-4' : 'translate-x-0'
        }`}
      ></button>
    </div>
  )
}
